import React, { useEffect, useState } from 'react'
import { LuxFormInput, LUX_INPUT_TYPE } from '../../Techedge-Wardrobe'
import LuxButton from '../buttons/Button'
import LuxTree from '../tree/Tree'
import './Columns.scss'

const DataColumns = (props: {
    items: any[]
    setItems: (items: any[]) => void
    selectedItems: any[]
    setSelectedItems: (selectedItems: any[]) => void
    originalItems: any[]
    itemsKeys: any
    setItemsKeys: (newItemsKeys: any) => void
    selectedItemsKeys: any
    setSelectedItemsKeys: (newSelectedItemsKeys: any) => void
    searchVal: string
    setSearchVal: (newSearchVal: string) => void
    onChangeSearch: (newVal: string) => void
    transferAll?: () => void
    resetAll?: () => void
    labels?: {
        transferAll?: string
        resetAll?: string
        moveToRight?: string
        moveToLeft?: string
        merge?: string
        separate?: string
        split?: string
    }
    showToast?: (
        severity?: string,
        summary?: string,
        detail?: string,
        life?: number
    ) => void
}) => {
    const {
        items,
        setItems,
        selectedItems,
        setSelectedItems,
        originalItems,
        itemsKeys,
        setItemsKeys,
        selectedItemsKeys,
        setSelectedItemsKeys,
        searchVal,
        setSearchVal,
        onChangeSearch,
        transferAll,
        resetAll,
        labels,
        showToast,
    } = props

    const [itemsToMerge, setItemsToMerge] = useState<string[]>([])
    const [itemsToSeparate, setItemsToSeparate] = useState<string[]>([])
    const [itemsToMoveLeft, setItemsToMoveLeft] = useState<string[]>([])
    const [itemsToMoveRight, setItemsToMoveRight] = useState<string[]>([])

    const getItem = (id: string, list?: 'items' | 'selectedItems') => {
        let _items = list
            ? list === 'items'
                ? [...items]
                : [...selectedItems]
            : originalItems
        for (let i = 0; i < _items.length; i++) {
            let item = _items[i]
            if (item.id === id) {
                return item
            }
            if (item?.children) {
                let children = item.children
                for (let c = 0; c < children.length; c++) {
                    let child: any = children[c]
                    if (child.id === id) {
                        return child
                    }
                }
            }
        }
        return undefined
    }

    const onTransferAll = () => {
        // -----------------------------------------
        setSearchVal('')
        // -----------------------------------------
        let tmpItems = [...originalItems]
        let tmpSelectedItems = [...selectedItems]
        // -----------------------------------------
        let filteredItems = []
        let filteredSelectedItems = []
        // -----------------------------------------
        for (let i = 0; i < tmpSelectedItems.length; i++) {
            let tmpSelectedItem = tmpSelectedItems[i]
            if (
                tmpSelectedItem?.parentId ||
                tmpSelectedItem?.combined?.length > 0
            ) {
                filteredSelectedItems.push(tmpSelectedItem)
            }
        }
        // -----------------------------------------
        let checkIds = []
        for (let i = 0; i < filteredSelectedItems.length; i++) {
            let filteredSelectedItem = filteredSelectedItems[i]
            if (filteredSelectedItem?.combined?.length > 0) {
                let filteredSelectedItemChildren = filteredSelectedItem.children
                for (let c = 0; c < filteredSelectedItemChildren.length; c++) {
                    let filteredSelectedItemChild =
                        filteredSelectedItemChildren[c]
                    checkIds.push(filteredSelectedItemChild.id)
                }
            } else if (filteredSelectedItem?.parentId) {
                checkIds.push(filteredSelectedItem.id)
            }
        }
        // -----------------------------------------
        for (let i = 0; i < tmpItems.length; i++) {
            let tmpItem = tmpItems[i]
            let newFilteredItem = { ...tmpItem }
            if (tmpItem?.children) {
                let newFilteredItemChildren = []
                let tmpItemChildren = tmpItem.children
                for (let c = 0; c < tmpItemChildren.length; c++) {
                    let tmpItemChild = tmpItemChildren[c]
                    let check = false
                    for (let x = 0; x < checkIds.length; x++) {
                        let id = checkIds[x]
                        if (tmpItemChild.id === id) {
                            check = true
                        }
                    }
                    if (!check) {
                        newFilteredItemChildren.push(tmpItemChild)
                    }
                }
                newFilteredItem.children = newFilteredItemChildren
            }
            if (newFilteredItem?.children?.length > 0) {
                filteredItems.push(newFilteredItem)
            }
        }
        // -----------------------------------------
        let newSelectedItems = filteredSelectedItems.concat(filteredItems)
        // -----------------------------------------
        setItems([])
        setSelectedItems(newSelectedItems)
    }

    const onResetAll = () => {
        if (resetAll) {
            resetAll()
        } else {
            setSelectedItems([])
            setItems(items.concat(selectedItems))
        }
    }

    const onMoveToRight = (itemsToMove: any) => {
        let entries: any = Object.entries(itemsToMove)
        let checked = entries.filter((e) => e[1].checked === true)
        let notChecked = entries.filter((e) => e[1].checked === false)
        // -----------------------------------------
        let tmpItems = [...items]
        let tmpSelectedItems = [...selectedItems]
        // -----------------------------------------
        let checkedIds = checked.map((e) => {
            return e[0]
        })
        let notCheckedIds = notChecked.map((e) => {
            return e[0]
        })
        // -----------------------------------------
        let tmpSelectedItemsIds = tmpSelectedItems.map((i) => {
            return i.id
        })
        // -----------------------------------------
        for (let i = 0; i < notCheckedIds.length; i++) {
            let id = notCheckedIds[i]
            let item = getItem(id, 'items')
            if (!tmpSelectedItemsIds.includes(id)) {
                let newItem = {
                    id: item.id,
                    key: item.key,
                    label: item.label,
                    content: item.content,
                    children: [],
                }
                tmpSelectedItems.push(newItem)
            }
        }
        // -----------------------------------------
        tmpSelectedItemsIds = tmpSelectedItems.map((i) => {
            return i.id
        })
        // -----------------------------------------
        for (let i = 0; i < checkedIds.length; i++) {
            let id = checkedIds[i]
            let item = getItem(id, 'items')
            if (item?.parentId) {
                if (!checkedIds.includes(item.parentId)) {
                    for (let s = 0; s < tmpSelectedItems.length; s++) {
                        let tmpSelectedItem = tmpSelectedItems[s]
                        if (tmpSelectedItem.id === item.parentId) {
                            let newChildren = tmpSelectedItem.children
                            newChildren.push(item)
                            tmpSelectedItem.children = newChildren
                        }
                    }
                }
            } else {
                if (tmpSelectedItemsIds.includes(item.id)) {
                    for (let s = 0; s < tmpSelectedItems.length; s++) {
                        let tmpSelectedItem = tmpSelectedItems[s]
                        if (tmpSelectedItem.id === item.id) {
                            let newChildren = []
                            let itemChildren = item.children
                            let tmpSelectedItemChildren =
                                tmpSelectedItem.children
                            newChildren =
                                tmpSelectedItemChildren.concat(itemChildren)
                            tmpSelectedItem.children = newChildren
                        }
                    }
                } else {
                    tmpSelectedItems.push(item)
                }
            }
        }
        // -----------------------------------------
        let newItems = []
        // -----------------------------------------
        for (let i = 0; i < tmpItems.length; i++) {
            let tmpItem = tmpItems[i]
            let newItem = {
                id: tmpItem.id,
                key: tmpItem.key,
                label: tmpItem.label,
                content: tmpItem.content,
                children: tmpItem?.children,
                combined: tmpItem?.combined,
            }
            for (let s = 0; s < tmpSelectedItems.length; s++) {
                let tmpSelectedItem = tmpSelectedItems[s]
                if (tmpSelectedItem.id === newItem.id) {
                    let newChildren = []
                    let newItemChildren = newItem.children
                    let tmpSelectedItemChildren = tmpSelectedItem.children
                    let tmpSelectedItemChildrenIds =
                        tmpSelectedItemChildren.map((c) => {
                            return c.id
                        })
                    for (let c = 0; c < newItemChildren.length; c++) {
                        let newItemChild = newItemChildren[c]
                        if (
                            !tmpSelectedItemChildrenIds.includes(
                                newItemChild.id
                            )
                        ) {
                            newChildren.push(newItemChild)
                        }
                    }
                    newItem.children = newChildren
                }
            }
            if (newItem?.children?.length > 0) {
                newItems.push(newItem)
            }
        }
        // -----------------------------------------
        setItemsKeys({})
        setSelectedItemsKeys({})
        setItems(newItems)
        setSelectedItems(tmpSelectedItems)
        // -----------------------------------------
    }

    const onMoveToLeft = (itemsToMove: any) => {
        let entries: any = Object.entries(itemsToMove)
        let checked = entries.filter((e) => e[1].checked === true)
        let notChecked = entries.filter((e) => e[1].checked === false)
        // -----------------------------------------
        let tmpItems = [...items]
        let tmpSelectedItems = [...selectedItems]
        // -----------------------------------------
        let checkedIds = checked.map((e) => {
            return e[0]
        })
        let notCheckedIds = notChecked.map((e) => {
            return e[0]
        })
        // -----------------------------------------
        let tmpItemsIds = tmpItems.map((i) => {
            return i.id
        })
        // -----------------------------------------
        for (let i = 0; i < notCheckedIds.length; i++) {
            let id = notCheckedIds[i]
            let item = getItem(id, 'selectedItems')
            if (!tmpItemsIds.includes(id)) {
                let newItem = {
                    id: item.id,
                    key: item.key,
                    label: item.label,
                    content: item.content,
                    children: [],
                }
                tmpItems.push(newItem)
            }
        }
        // -----------------------------------------
        tmpItemsIds = tmpItems.map((i) => {
            return i.id
        })
        // -----------------------------------------
        for (let i = 0; i < checkedIds.length; i++) {
            let id = checkedIds[i]
            let item = getItem(id, 'selectedItems')
            if (item?.isSeparated) {
                let check = false
                for (let s = 0; s < tmpItems.length; s++) {
                    let tmpItem = tmpItems[s]
                    if (tmpItem.id === item.parentId) {
                        check = true
                        let newChildren = []
                        let tmpItemChildren = tmpItem.children
                        item.label = item.label.split('(')[0]
                        item.content = item.label.split('(')[0]
                        delete item.isSeparated
                        newChildren.push(item)
                        tmpItem.children = tmpItemChildren.concat(newChildren)
                        break
                    }
                }
                if (!check) {
                    item.label = item.label.split('(')[0]
                    item.content = item.label.split('(')[0]
                    delete item.isSeparated
                    let newItem = {
                        id: item.parentId,
                        key: item.parentId,
                        label: item.parentName,
                        content: item.parentName,
                        children: [item],
                    }
                    tmpItems.push(newItem)
                }
            } else if (item?.parentId) {
                if (!checkedIds.includes(item.parentId)) {
                    for (let s = 0; s < tmpItems.length; s++) {
                        let tmpItem = tmpItems[s]
                        if (tmpItem.id === item.parentId) {
                            let newChildren = tmpItem.children
                            newChildren.push(item)
                            tmpItem.children = newChildren
                            break
                        }
                    }
                }
            } else {
                if (tmpItemsIds.includes(item.id)) {
                    for (let s = 0; s < tmpItems.length; s++) {
                        let tmpItem = tmpItems[s]
                        if (tmpItem.id === item.id) {
                            let newChildren = []
                            let itemChildren = item.children
                            let tmpItemChildren = tmpItem.children
                            newChildren = tmpItemChildren.concat(itemChildren)
                            tmpItem.children = newChildren
                            break
                        }
                    }
                } else {
                    tmpItems.push(item)
                }
            }
        }
        // -----------------------------------------
        let newSelectedItems = []
        // -----------------------------------------
        for (let i = 0; i < tmpSelectedItems.length; i++) {
            let tmpSelectedItem = tmpSelectedItems[i]
            if (tmpSelectedItem?.isSeparated) {
                let newSelectedItem = {
                    id: tmpSelectedItem.id,
                    key: tmpSelectedItem.key,
                    label: tmpSelectedItem.label,
                    content: tmpSelectedItem.content,
                    parentId: tmpSelectedItem.parentId,
                    parentName: tmpSelectedItem.parentName,
                    isSeparated: tmpSelectedItem.isSeparated,
                }
                newSelectedItems.push(newSelectedItem)
            } else {
                let newSelectedItem = {
                    id: tmpSelectedItem.id,
                    key: tmpSelectedItem.key,
                    label: tmpSelectedItem.label,
                    content: tmpSelectedItem.content,
                    children: tmpSelectedItem?.children,
                    combined: tmpSelectedItem?.combined,
                }
                for (let s = 0; s < tmpItems.length; s++) {
                    let tmpItem = tmpItems[s]
                    if (tmpItem.id === newSelectedItem.id) {
                        let newChildren = []
                        let newSelectedItemChildren = newSelectedItem.children
                        let tmpItemChildren = tmpItem.children
                        let tmpItemChildrenIds = tmpItemChildren.map((c) => {
                            return c.id
                        })
                        for (
                            let c = 0;
                            c < newSelectedItemChildren.length;
                            c++
                        ) {
                            let newSelectedItemChild =
                                newSelectedItemChildren[c]
                            if (
                                !tmpItemChildrenIds.includes(
                                    newSelectedItemChild.id
                                )
                            ) {
                                newChildren.push(newSelectedItemChild)
                            }
                        }
                        newSelectedItem.children = newChildren
                    }
                }
                if (newSelectedItem?.children?.length > 0) {
                    newSelectedItems.push(newSelectedItem)
                }
            }
        }
        // -----------------------------------------
        setItemsKeys({})
        setSelectedItemsKeys({})
        setItems(tmpItems)
        setSelectedItems(newSelectedItems)
        // -----------------------------------------
    }

    const onSeparate = (itemsToSeparate: any) => {
        let entries: any = Object.entries(itemsToSeparate)
        let entriesChecked = entries.filter((e) => e[1].checked === true)
        let entriesNotChecked = entries.filter((e) => e[1].checked === false)
        let entriesNotCheckedIds = []
        // -----------------------------------------
        for (let i = 0; i < entriesNotChecked.length; i++) {
            entriesNotCheckedIds.push(entriesNotChecked[i][0])
        }
        // -----------------------------------------
        let tmpSelectedItems = [...selectedItems]
        // -----------------------------------------
        let separatedItems = []
        let separatedItemsIds = []
        let newSelectedItems = []
        let selectedItemsIdsToExclude = []
        // -----------------------------------------
        for (let i = 0; i < entriesChecked.length; i++) {
            let entry = entriesChecked[i]
            let key = entry[0]
            let item = getItem(key, 'selectedItems')
            if (item?.parentId) {
                let match = entriesNotCheckedIds.find((e) => {
                    if (e.includes(item.parentId)) {
                        return true
                    }
                })
                if (match) {
                    let newLabel = item.label + ' (' + item.parentName + ')'
                    item.label = newLabel
                    item.content = newLabel
                    item.isSeparated = true
                    separatedItems.push(item)
                    separatedItemsIds.push(item.id)
                }
            }
            if (item?.children) {
                let children = item.children
                for (let c = 0; c < children.length; c++) {
                    let child = children[c]
                    let childNewLabel =
                        child.label + ' (' + child.parentName + ')'
                    child.label = childNewLabel
                    child.content = childNewLabel
                    child.isSeparated = true
                    separatedItems.push(child)
                    separatedItemsIds.push(child.id)
                }
                selectedItemsIdsToExclude.push(item.id)
            }
        }
        for (let i = 0; i < tmpSelectedItems.length; i++) {
            let selectedItem = tmpSelectedItems[i]
            if (selectedItem?.children) {
                let children = selectedItem.children
                let newChildren = []
                for (let c = 0; c < children.length; c++) {
                    let child = children[c]
                    if (!separatedItemsIds.includes(child.id)) {
                        newChildren.push(child)
                    }
                }
                selectedItem.children = newChildren
            }
            if (!selectedItemsIdsToExclude.includes(selectedItem.id)) {
                newSelectedItems.push(selectedItem)
            }
        }
        // -----------------------------------------
        if (separatedItems?.length === 0 && entriesChecked?.length === 2) {
            let check = false
            let first = getItem(entriesChecked[0][0], 'selectedItems')
            let second = getItem(entriesChecked[1][0], 'selectedItems')
            let parent: any = {}
            let child: any = {}
            if (first?.children && first.id === second?.parentId) {
                check = true
                child = second
                parent = first
            } else if (second?.children && first?.parentId === second.id) {
                check = true
                child = first
                parent = second
            }
            if (check) {
                newSelectedItems = newSelectedItems.filter((s) => {
                    return s.id !== parent.id
                })
                let newSeparatedItem = {
                    id: child.id,
                    key: child.key,
                    label: child.label + ' (' + parent.label + ')',
                    content: child.content + ' (' + parent.content + ')',
                    parentId: parent.id,
                    parentName: parent.label,
                    isSeparated: true,
                }
                separatedItems.push(newSeparatedItem)
            }
        }
        // -----------------------------------------
        newSelectedItems = newSelectedItems.concat(separatedItems)
        // -----------------------------------------
        setSelectedItemsKeys({})
        setSelectedItems(newSelectedItems)
    }

    const onMerge = (itemsToMerge: any) => {
        let entries: any = Object.entries(itemsToMerge)
        let entriesChecked = entries.filter((e) => e[1].checked === true)
        let entriesCheckedIds = entriesChecked.map((e) => {
            return e[0]
        })
        // -----------------------------------------
        let tmpSelectedItems = [...selectedItems]
        // -----------------------------------------
        let mergedItems = []
        let mergedItemsIds = []
        let mergedItemsSeparated = []
        let mergedItemsSeparatedIds = []
        for (let i = 0; i < entriesCheckedIds.length; i++) {
            let id = entriesCheckedIds[i]
            let item = getItem(id, 'selectedItems')
            if (item?.isSeparated) {
                mergedItemsSeparated.push(item)
                mergedItemsSeparatedIds.push(item.id)
            } else if (!item?.parentId) {
                mergedItems.push(item)
                mergedItemsIds.push(item.id)
            }
        }
        // -----------------------------------------
        let newCombinedItem = {
            id: '',
            key: '',
            label: '',
            content: '',
            children: [],
            combined: [],
        }
        let newCombinedItemChildren = []
        // -----------------------------------------
        for (let i = 0; i < mergedItems.length; i++) {
            let item = mergedItems[i]
            newCombinedItem.id += item.id
            newCombinedItem.key += item.key
            if (i !== mergedItems.length - 1) {
                newCombinedItem.id += '-'
                newCombinedItem.key += '-'
            }
            newCombinedItem.label += item.label
            newCombinedItem.content += item.content
            if (i !== mergedItems.length - 1) {
                newCombinedItem.label += ', '
                newCombinedItem.content += ', '
            }
            if (item?.children) {
                let children = item.children
                for (let c = 0; c < children.length; c++) {
                    let child = children[c]
                    newCombinedItemChildren.push(child)
                }
            }
            newCombinedItem.combined.push(item)
        }
        // -----------------------------------------
        for (let i = 0; i < mergedItemsSeparated.length; i++) {
            let item = mergedItemsSeparated[i]
            let errorSegment: any = {}
            let errorStore: any = {}
            let check = true
            for (let x = 0; x < mergedItems.length; x++) {
                let mergedItem = mergedItems[x]
                let mergedItemCombinedIds = mergedItem?.combined?.map((c) => {
                    return c.id
                })
                if (
                    mergedItem.id !== item.parentId &&
                    !mergedItemCombinedIds?.includes(item.parentId)
                ) {
                    check = false
                    errorStore = item
                    errorSegment = mergedItem
                }
            }
            if (check) {
                item.label = item.label.split('(')[0]
                item.content = item.content.split('(')[0]
                delete item.isSeparated
                delete newCombinedItem.combined
                newCombinedItemChildren.push(item)
            } else {
                showToast &&
                    showToast(
                        'error',
                        'Incompatible Items',
                        'Is not possible to associate ' +
                            errorStore.label +
                            ' with Segment ' +
                            errorSegment.label
                    )
                return
            }
        }
        // -----------------------------------------
        if (newCombinedItemChildren?.length > 0) {
            newCombinedItem.children = newCombinedItemChildren
        } else {
            delete newCombinedItem.children
        }
        // -----------------------------------------
        let newSelectedItems = []
        for (let i = 0; i < tmpSelectedItems.length; i++) {
            let item = tmpSelectedItems[i]
            if (
                !mergedItemsIds.includes(item.id) &&
                !mergedItemsSeparatedIds.includes(item.id)
            ) {
                newSelectedItems.push(item)
            }
        }
        // -----------------------------------------
        newSelectedItems.push(newCombinedItem)
        // -----------------------------------------
        setSelectedItemsKeys({})
        setSelectedItems(newSelectedItems)
    }

    const onSplit = (parentId: string, itemsToSplit: any) => {
        let tmpItems = [...items]
        let tmpSelectedItems = [...selectedItems]
        let allItemsIds = []
        let newSelectedItems = []
        for (let i = 0; i < tmpItems.length; i++) {
            let item = tmpItems[i]
            allItemsIds.push(item.id)
        }
        for (let i = 0; i < tmpSelectedItems.length; i++) {
            let selectedItem = tmpSelectedItems[i]
            if (selectedItem.id !== parentId) {
                newSelectedItems.push(selectedItem)
                allItemsIds.push(selectedItem.id)
            }
        }
        for (let i = 0; i < itemsToSplit.length; i++) {
            let item = itemsToSplit[i]
            if (item?.combined) {
                let combinedItems = item.combined
                for (let c = 0; c < combinedItems.length; c++) {
                    let combinedItem = combinedItems[c]
                    newSelectedItems.push(combinedItem)
                }
            } else {
                if (item?.children) {
                    let children = item.children
                    let newChildren = []
                    for (let c = 0; c < children.length; c++) {
                        let child = children[c]
                        if (!allItemsIds.includes(child.id)) {
                            newChildren.push(child)
                        }
                    }
                    item.children = newChildren
                }
                newSelectedItems.push(item)
            }
        }
        setSelectedItems(newSelectedItems)
    }

    // USE EFFECTS

    useEffect(() => {
        if (itemsKeys) {
            let entries: any[] = Object.entries(itemsKeys)
            let entriesChecked = entries.filter((e) => e[1].checked === true)
            let entriesToMoveRight = []
            if (entriesChecked?.length > 0) {
                let childrenIds = []
                for (let i = 0; i < entriesChecked.length; i++) {
                    let entry = entriesChecked[i]
                    let item = getItem(entry[0], 'items')
                    if (item?.children) {
                        let children = item.children
                        for (let c = 0; c < children.length; c++) {
                            let child = children[c]
                            childrenIds.push(child?.id)
                        }
                    }
                }
                for (let i = 0; i < entriesChecked.length; i++) {
                    let entry = entriesChecked[i]
                    let item = getItem(entry[0], 'items')
                    if (!childrenIds.includes(item?.id)) {
                        entriesToMoveRight.push(item)
                    }
                }
            }
            entriesToMoveRight?.length > 0
                ? setItemsToMoveRight(entriesToMoveRight)
                : setItemsToMoveRight([])
        }
    }, [itemsKeys])

    useEffect(() => {
        if (selectedItemsKeys) {
            let entries: any[] = Object.entries(selectedItemsKeys)
            let entriesChecked = entries.filter((e) => e[1].checked === true)
            let entriesToMerge = []
            let entriesToSeparate = []
            let entriesToMoveLeft = []
            let atLeastOneItemNotSeparated = false
            if (entriesChecked?.length > 0) {
                let childrenIds = []
                for (let i = 0; i < entriesChecked.length; i++) {
                    let entry = entriesChecked[i]
                    let item = getItem(entry[0], 'selectedItems')
                    if (!item) {
                        setSelectedItemsKeys({})
                    }
                    if (item?.children) {
                        let children = item.children
                        for (let c = 0; c < children.length; c++) {
                            let child = children[c]
                            childrenIds.push(child?.id)
                        }
                    }
                }
                for (let i = 0; i < entriesChecked.length; i++) {
                    let entry = entriesChecked[i]
                    let item = getItem(entry[0], 'selectedItems')
                    if (!childrenIds.includes(item?.id)) {
                        entriesToMoveLeft.push(item)
                        if (item?.isSeparated || !item?.parentId) {
                            entriesToMerge.push(item)
                            if (!item?.isSeparated) {
                                atLeastOneItemNotSeparated = true
                            }
                        }
                        if (!item?.isSeparated) {
                            entriesToSeparate.push(item)
                            atLeastOneItemNotSeparated = true
                        }
                    }
                }
                if (entriesChecked.length === 2 && childrenIds.length === 1) {
                    let item = getItem(childrenIds[0], 'selectedItems')
                    entriesToSeparate.push(item)
                }
            }
            entriesToMerge?.length > 1 && atLeastOneItemNotSeparated
                ? setItemsToMerge(entriesToMerge)
                : setItemsToMerge([])
            entriesToSeparate?.length > 0
                ? setItemsToSeparate(entriesToSeparate)
                : setItemsToSeparate([])
            entriesToMoveLeft?.length > 0
                ? setItemsToMoveLeft(entriesToMoveLeft)
                : setItemsToMoveLeft([])
        }
    }, [selectedItemsKeys])

    return (
        <div className="dataColumns">
            <div className="dataColumn">
                <div className="dataColumnSearch">
                    <LuxFormInput
                        value={[searchVal]}
                        type={LUX_INPUT_TYPE.text}
                        icon="search"
                        colWidth="auto"
                        placeholder="Search"
                        onChangeCallback={(e: any) => onChangeSearch(e)}
                    />
                </div>
                <LuxTree
                    items={items}
                    itemsKeys={itemsKeys}
                    setItemsKeys={setItemsKeys}
                />
                <div className="dataColumnActions">
                    <div></div>
                    <div>
                        <LuxButton
                            color={'005192'}
                            variant={['text']}
                            text={
                                labels?.transferAll
                                    ? labels.transferAll
                                    : 'Transfer all'
                            }
                            onClick={onTransferAll}
                            disabled={
                                items?.length < 1 ||
                                Object.entries(itemsKeys).length > 0
                                    ? true
                                    : false
                            }
                        />
                        <LuxButton
                            color={'005192'}
                            variant={['primary']}
                            icon={'arrow-right'}
                            iconPos={'right'}
                            text={
                                labels?.moveToRight
                                    ? labels.moveToRight
                                    : 'Move to Right'
                            }
                            onClick={() => onMoveToRight(itemsKeys)}
                            disabled={
                                itemsToMoveRight?.length > 0 ? false : true
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="dataColumn">
                <LuxTree
                    items={selectedItems}
                    itemsKeys={selectedItemsKeys}
                    setItemsKeys={setSelectedItemsKeys}
                    onSplit={onSplit}
                />
                <div className="dataColumnActions">
                    <div>
                        <LuxButton
                            color={'005192'}
                            variant={['primary']}
                            icon={'arrow-left'}
                            iconPos={'left'}
                            text={
                                labels?.moveToLeft
                                    ? labels.moveToLeft
                                    : 'Move to Left'
                            }
                            onClick={() => onMoveToLeft(selectedItemsKeys)}
                            disabled={
                                itemsToMoveLeft?.length > 0 ? false : true
                            }
                        />
                    </div>
                    <div>
                        <LuxButton
                            color={'005192'}
                            variant={['text']}
                            text={labels?.merge ? labels.merge : 'Merge'}
                            onClick={() => onMerge(selectedItemsKeys)}
                            disabled={itemsToMerge?.length > 0 ? false : true}
                        />
                        <LuxButton
                            color={'005192'}
                            variant={['text']}
                            text={
                                labels?.separate ? labels.separate : 'Separate'
                            }
                            onClick={() => onSeparate(selectedItemsKeys)}
                            disabled={
                                itemsToSeparate?.length > 0 ? false : true
                            }
                        />
                        <LuxButton
                            color={'005192'}
                            variant={['text']}
                            text={
                                labels?.resetAll ? labels.resetAll : 'Reset all'
                            }
                            onClick={onResetAll}
                            disabled={
                                selectedItems?.length < 1 ||
                                Object.entries(selectedItemsKeys).length > 0
                                    ? true
                                    : false
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DataColumns
